// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fare Studio (redesign): modern pricing list matching Category Studio. Tokens w/ fallbacks. */

.PricingStudio-toolbar-xG91V {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-bottom: 16px;
}

.PricingStudio-filters-XzzvV {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.PricingStudio-searchInput-L1MGI {
  min-width: 240px;
}

.PricingStudio-filterSelect-n4djg {
  min-width: 150px;
}

.PricingStudio-list-xWDsT {
  list-style: none;
  margin: 0;
  padding: 0;
}

.PricingStudio-row-V_YZB {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 14px;
  padding: 12px 14px;
  margin-bottom: 8px;
  background: #ffffff;
  background: var(--white-color, #ffffff);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  -webkit-transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
}

.PricingStudio-row-V_YZB:hover {
  border-color: #d32f2f;
  border-color: var(--primary-bg, #d32f2f);
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.PricingStudio-priceBlock-oGlkW {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-width: 92px;
  padding: 6px 10px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  background: #f9f9f9;
  background: var(--common-light-bg, #f9f9f9);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
}

.PricingStudio-price-kkpeR {
  font-weight: 800;
  font-size: 16px;
  color: #d32f2f;
  color: var(--primary-bg, #d32f2f);
  line-height: 1.1;
}

.PricingStudio-priceUnit-_w_6z {
  font-size: 11px;
  color: #909090;
  color: var(--content-text-secondary, #909090);
  white-space: nowrap;
}

.PricingStudio-mainCol-zFspK {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  min-width: 140px;
}

.PricingStudio-subName-vYBvX {
  font-weight: 600;
  color: #181817;
  color: var(--content-text, #181817);
}

.PricingStudio-meta-x4ZOF {
  font-size: 12px;
  color: #909090;
  color: var(--content-text-secondary, #909090);
}

.PricingStudio-catBadge-w6CNp {
  font-size: 11px;
  color: #606060;
  color: var(--content-text-secondary, #606060);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 999px;
  padding: 2px 10px;
  white-space: nowrap;
}

.PricingStudio-locationBadge-gHmxe {
  font-size: 12px;
  color: #181817;
  color: var(--content-text, #181817);
  white-space: nowrap;
}

.PricingStudio-editableBadge-RVw9R {
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: #0e9488;
  border-radius: 999px;
  padding: 2px 7px;
  white-space: nowrap;
}

.PricingStudio-statusSelect-Lp7zR {
  min-width: 120px;
}

.PricingStudio-statusActive-P8Rdw {
  color: #03a83b;
  font-weight: 600;
}

.PricingStudio-statusInactive-ybYiB {
  color: #ff4c4c;
  font-weight: 600;
}

.PricingStudio-actions-hywkw {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
}

.PricingStudio-actionLink-KYWwn,
.PricingStudio-actionBtn-RTvrd {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  background: #ffffff;
  background: var(--white-color, #ffffff);
  cursor: pointer;
  color: #181817;
  color: var(--content-text, #181817);
  text-decoration: none;
}

.PricingStudio-actionLink-KYWwn:hover,
.PricingStudio-actionBtn-RTvrd:hover {
  border-color: #d32f2f;
  border-color: var(--primary-bg, #d32f2f);
  color: #d32f2f;
  color: var(--primary-bg, #d32f2f);
}

.PricingStudio-icon-HOOnk {
  width: 16px;
  height: 16px;
}

.PricingStudio-empty-nK60J {
  padding: 32px;
  text-align: center;
  color: #606060;
  color: var(--content-text-secondary, #606060);
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteAdmin/Pricing/PricingList/PricingStudio.css"],"names":[],"mappings":"AAAA,+FAA+F;;AAE/F;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAuC;EAAvC,uCAAuC;EACvC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,0EAA0D;EAA1D,kEAA0D;EAA1D,0DAA0D;EAA1D,yFAA0D;AAC5D;;AAEA;EACE,qBAAwC;EAAxC,wCAAwC;EACxC,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAmC;EAAnC,mCAAmC;EACnC,mBAA2C;EAA3C,2CAA2C;EAC3C,yBAA8C;EAA9C,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAiC;EAAjC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,yBAA8C;EAA9C,8CAA8C;EAC9C,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAmC;EAAnC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAuC;EAAvC,uCAAuC;EACvC,eAAe;EACf,cAAmC;EAAnC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;EAEE,qBAAwC;EAAxC,wCAAwC;EACxC,cAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAA6C;EAA7C,6CAA6C;AAC/C","sourcesContent":["/* Fare Studio (redesign): modern pricing list matching Category Studio. Tokens w/ fallbacks. */\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.searchInput {\n  min-width: 240px;\n}\n\n.filterSelect {\n  min-width: 150px;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  margin-bottom: 8px;\n  background: var(--white-color, #ffffff);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.row:hover {\n  border-color: var(--primary-bg, #d32f2f);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.priceBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 92px;\n  padding: 6px 10px;\n  border-radius: var(--radius-1, 6px);\n  background: var(--common-light-bg, #f9f9f9);\n  border: 1px solid var(--border-color, #e4e4e4);\n}\n\n.price {\n  font-weight: 800;\n  font-size: 16px;\n  color: var(--primary-bg, #d32f2f);\n  line-height: 1.1;\n}\n\n.priceUnit {\n  font-size: 11px;\n  color: var(--content-text-secondary, #909090);\n  white-space: nowrap;\n}\n\n.mainCol {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 140px;\n}\n\n.subName {\n  font-weight: 600;\n  color: var(--content-text, #181817);\n}\n\n.meta {\n  font-size: 12px;\n  color: var(--content-text-secondary, #909090);\n}\n\n.catBadge {\n  font-size: 11px;\n  color: var(--content-text-secondary, #606060);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: 999px;\n  padding: 2px 10px;\n  white-space: nowrap;\n}\n\n.locationBadge {\n  font-size: 12px;\n  color: var(--content-text, #181817);\n  white-space: nowrap;\n}\n\n.editableBadge {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  background: #0e9488;\n  border-radius: 999px;\n  padding: 2px 7px;\n  white-space: nowrap;\n}\n\n.statusSelect {\n  min-width: 120px;\n}\n\n.statusActive {\n  color: #03a83b;\n  font-weight: 600;\n}\n\n.statusInactive {\n  color: #ff4c4c;\n  font-weight: 600;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.actionLink,\n.actionBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-1, 6px);\n  border: 1px solid var(--border-color, #e4e4e4);\n  background: var(--white-color, #ffffff);\n  cursor: pointer;\n  color: var(--content-text, #181817);\n  text-decoration: none;\n}\n\n.actionLink:hover,\n.actionBtn:hover {\n  border-color: var(--primary-bg, #d32f2f);\n  color: var(--primary-bg, #d32f2f);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n.empty {\n  padding: 32px;\n  text-align: center;\n  color: var(--content-text-secondary, #606060);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `PricingStudio-toolbar-xG91V`,
	"filters": `PricingStudio-filters-XzzvV`,
	"searchInput": `PricingStudio-searchInput-L1MGI`,
	"filterSelect": `PricingStudio-filterSelect-n4djg`,
	"list": `PricingStudio-list-xWDsT`,
	"row": `PricingStudio-row-V_YZB`,
	"priceBlock": `PricingStudio-priceBlock-oGlkW`,
	"price": `PricingStudio-price-kkpeR`,
	"priceUnit": `PricingStudio-priceUnit-_w_6z`,
	"mainCol": `PricingStudio-mainCol-zFspK`,
	"subName": `PricingStudio-subName-vYBvX`,
	"meta": `PricingStudio-meta-x4ZOF`,
	"catBadge": `PricingStudio-catBadge-w6CNp`,
	"locationBadge": `PricingStudio-locationBadge-gHmxe`,
	"editableBadge": `PricingStudio-editableBadge-RVw9R`,
	"statusSelect": `PricingStudio-statusSelect-Lp7zR`,
	"statusActive": `PricingStudio-statusActive-P8Rdw`,
	"statusInactive": `PricingStudio-statusInactive-ybYiB`,
	"actions": `PricingStudio-actions-hywkw`,
	"actionLink": `PricingStudio-actionLink-KYWwn`,
	"actionBtn": `PricingStudio-actionBtn-RTvrd`,
	"icon": `PricingStudio-icon-HOOnk`,
	"empty": `PricingStudio-empty-nK60J`
};
module.exports = ___CSS_LOADER_EXPORT___;
